export const getGoogleMapsURL = (coordinates = {lat: 0, long: 0}) => {

    const lat = coordinates.lat
    const long = coordinates.long
    const URLString = `https://www.google.com/maps/dir/?api=1&destination=${lat},${long}&travelmode=driving`

    return URLString
}